// Slovak translations
export const sk: Record<string, string> = {
  'menu.dashboard': 'Prehľad',
  'menu.orderNew': 'Registrácia produktu',
  'menu.customers': 'Zákazníci',
  'menu.products': 'Produkty',
  'menu.users': 'Používatelia',
  'menu.settings': 'Nastavenia',
  'menu.logout': 'Odhlásiť',
  'dashboard.title': 'Prehľad',
  'dashboard.todaySales': 'Predaj dnes',
  'dashboard.totalOrders': 'Celkové objednávky',
  'dashboard.newOrder': 'Nová objednávka',
  'dashboard.newCustomer': 'Nový zákazník',
  'order.title': 'Nová objednávka',
  'order.customer': 'Zákazník',
  'order.products': 'Produkty',
  'order.quantity': 'Množstvo',
  'order.price': 'Cena',
  'order.total': 'Celkom',
  'order.payment': 'Platba',
  'order.cash': 'Hotovosť',
  'order.card': 'Karta',
  'users.title': 'Používatelia',
  'users.name': 'Meno',
  'users.email': 'Email',
  'users.role': 'Rola',
  'users.edit': 'Upraviť',
  'users.delete': 'Vymazať',
  'common.yes': 'Áno',
  'common.no': 'Nie',
  'common.cancel': 'Zrušiť',
  'common.save': 'Uložiť',
  'common.search': 'Hľadať',
  'common.loading': 'Načítavanie...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Prihlásiť',
  'login.enterPin': 'Zadajte PIN',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Registrácia',
  'signup.createAccount': 'Vytvoriť účet',
  'signup.email': 'Email',
  'signup.phone': 'Telefón',
  'menu.reportsAndAccounting': 'Prehľady a účtovníctvo',
  'menu.systemAndCommunication': 'Systém a komunikácia',
};
